import config from 'lib/config';
import { createInstance } from '@optimizely/react-sdk';
import { AbTestingData } from './EventLogger/Event';

const optimizelyClient = createInstance({ sdkKey: config.optimizelySdkKey, logLevel: 4 });

export const getExperiments = (): AbTestingData => {
  try {
    const allFeatures = optimizelyClient.decideAll();

    // transform object to only have variationKey as value
    return Object.entries(allFeatures).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: value.variationKey,
      }),
      {}
    );
  } catch (e) {
    console.error('Optimizely ERROR: getExperiments ', e);
    return {};
  }
};

export default optimizelyClient;
